import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Youtube } from 'lucide-react';
import { NUMEROLOGY_URL } from "../config";

// TikTok Logo Component
const TikTokIcon = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container">
        <div className="max-w-6xl mx-auto">
          {/* Main Footer Content */}
          <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 mb-12">
            {/* Brand */}
            <div className="lg:col-span-2">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <img
                  src="/logo-desyclare.png"
                  alt="Desy Clare Logo"
                  className="h-8 w-8 object-contain"
                />
                <span className="text-xl font-semibold text-white">Desy Clare</span>
              </Link>
              
              <p className="text-base text-white mb-6 max-w-md leading-relaxed opacity-90">
                Platform numerologi dan spiritual modern untuk membantu Anda mengenal dan menyadari diri 
                lebih dalam serta menemukan arah hidup yang sesuai dengan tujuan jiwa.
              </p>
              
              <div className="flex items-center gap-4">
                <a 
                  href="https://instagram.com/desyclare" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center text-white hover:bg-amber-500 hover:text-white transition-all duration-300 hover:scale-110"
                >
                  <Instagram className="h-5 w-5" />
                </a>
                <a 
                  href="https://youtube.com/@desyclare" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center text-white hover:bg-amber-500 hover:text-white transition-all duration-300 hover:scale-110"
                >
                  <Youtube className="h-5 w-5" />
                </a>
                <a 
                  href="https://tiktok.com/@desyclare" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center text-white hover:bg-amber-500 hover:text-white transition-all duration-300 hover:scale-110"
                >
                  <TikTokIcon className="h-5 w-5" />
                </a>
              </div>
            </div>
            
            {/* Navigation */}
            <div>
              <h4 className="text-lg font-semibold text-white mb-4">Navigasi</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-base text-white hover:text-amber-400 transition-colors duration-200 opacity-90 hover:opacity-100">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/info" className="text-base text-white hover:text-amber-400 transition-colors duration-200 opacity-90 hover:opacity-100">
                    Info
                  </Link>
                </li>
                <li>
                  {/*<Link to="/numerology" className="text-base text-white hover:text-amber-400 transition-colors duration-200 opacity-90 hover:opacity-100">
                    Numerology Form
                  </Link>*/}
                  <a href={NUMEROLOGY_URL} className="text-base text-white hover:text-amber-400 transition-colors duration-200 opacity-90 hover:opacity-100">
                    Numerologi
                  </a>
                </li>
              </ul>
            </div>
            
            {/* Legal */}
            <div>
              <h4 className="text-lg font-semibold text-white mb-4">Legal</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/privacy" className="text-base text-white hover:text-amber-400 transition-colors duration-200 opacity-90 hover:opacity-100">
                    Kebijakan Privasi
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="text-base text-white hover:text-amber-400 transition-colors duration-200 opacity-90 hover:opacity-100">
                    Ketentuan Penggunaan
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-base text-white hover:text-amber-400 transition-colors duration-200 opacity-90 hover:opacity-100">
                    Hubungi Kami
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Bottom Bar */}
          <div className="border-t border-gray-600 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="text-sm text-white opacity-80">
                © 2025 Desy Clare. All rights reserved.
              </div>
              
              <div className="text-sm text-white opacity-80">
                Made with 💚 for your spiritual journey
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};